export function getCurrentCampusCode(currentCampus, campusData) {
  const idx = (currentCampus ?? 1) - 1;
  const list = campusData?.campusList ?? [];
  const fromIndex = list[idx]?.code;
  return (fromIndex && String(fromIndex).toLowerCase()) || "_default";
}

export function getCurrentLocationZoom(campusConfig, campusCode) {
  const map = campusConfig?.currentLocationZoom || {};
  return map[campusCode] ?? map._default ?? 3.0;
}

export function getMapNorthOffsetDeg(campusData, campusCode) {
  const list = campusData?.campusList ?? [];

  const entry = list.find(
    (c) => String(c.code).toLowerCase() === String(campusCode).toLowerCase()
  );
  return entry?.map?.northOffsetDeg ?? 0;
}

export function getGpsMarkerConfig(campusData, campusCode) {
  const list = campusData?.campusList ?? [];
  const entry = list.find(
    (c) => String(c.code).toLowerCase() === String(campusCode).toLowerCase()
  );

  return entry?.map?.gpsMarker || {};
}
